import { APPS } from '@/data/apps'
import { resolveIcon } from '@/lib/icon-resolver'
import { externalUrlAppsService } from '@/services/external-url-apps-service'

/** A window's icon: its registry entry, else the URL app's icon from Cortex (#1505). */
export function windowAppIcon(appId: string) {
  const app = APPS.find((a) => a.id === appId)
  if (app) return app.Icon
  const urlApp = externalUrlAppsService.getCachedApp(appId)
  return urlApp ? resolveIcon(urlApp.icon) : undefined
}
